// hooks
import { useAuth } from "frontend/hooks/useAuth";
import { useMyModerator } from "frontend/components/fort/mod/photos/hooks/useMyModerator.js";

const useIsAdmin = () => {
    const { currentUser } = useAuth() || {};
    const { myModProfile: myPhotoModProfile } = useMyModerator() || {};

    const moderatorId = myPhotoModProfile?.moderatorId;
    const isSuperuser = currentUser?.isSuperuser;
    const isAdmin = !!(moderatorId || isSuperuser);

    return { isAdmin };
};

export default useIsAdmin;
